import type { FC } from 'react';
import SearchProducts from '../SearchProducts';
import EmptyBanner from '@components/EmptyBanner';
import { searchNoResult } from '@images';
import { observer } from 'mobx-react';
import { Link } from '@compat/router';
import type { HeaderSearchSettings } from '../..';
import LoadingPage from '@components/LoadingPage';
import './index.scss';

const SearchContent: FC<
  Pick<HeaderSearchSettings, 'isLoading' | 'searchValue'> & {
    categories: NonNullable<HeaderSearchSettings['searchData']>['categories'];
    products: NonNullable<HeaderSearchSettings['searchData']>['products'];
  }
> = ({ isLoading, searchValue, categories, products }) => (
  <div className='search-content custom-scroll'>
    <div className='bg-white rounded-lg'>
      {/* {categories?.length > 0 && (
        <SearchCategory categories={categories} />
      )} */}
      {products?.length > 0 && <SearchProducts products={products} />}
      {products.length === 0 && categories.length === 0 ? (
        isLoading ? (
          <LoadingPage className='min-h-0 py-6 mt-0' />
        ) : (
          <EmptyBanner
            title='Поиск не дал результатов'
            description='К сожалению то, что Вы искали не найдено или не существует'
            img={searchNoResult}
            link='/catalog'
            height='120'
          />
        )
      ) : searchValue ? (
        <Link
          to={`/search?query=${searchValue}`}
          className='mt-5 flex w-[238px] items-center h-11 text-sm justify-center transition-colors mx-auto hover:bg-[var(--dark-red)] hover:text-white border border-solid rounded-lg'
        >
          Показать больше товаров
        </Link>
      ) : null}
    </div>
  </div>
);

export default observer(SearchContent);
